import * as Three from 'three';
import React from 'react';

const material = new Three.MeshLambertMaterial({ color: 0xf5f4f4 });

export default {
  name: 'square column',
  prototype: 'items',

  info: {
    tag: ['structure'],
    title: 'Square column',
    description: 'Square column',
    image: require('./square_column.png')
  },

  properties: {
    // altitude: {
    //   label: 'altitude',
    //   type: 'length-measure',
    //   defaultValue: {
    //     length: 0,
    //     unit: 'cm'
    //   }
    // },
    // height: {
    //   label: 'height',
    //   type: 'length-measure',
    //   defaultValue: {
    //     length: 300,
    //     unit: 'cm'
    //   }
    // },
    width: {
      label: 'width',
      type: 'length-measure',
      defaultValue: {
        length: 60,
        unit: 'cm'
      }
    },
    depth: {
      label: 'depth',
      type: 'length-measure',
      defaultValue: {
        length: 60,
        unit: 'cm'
      }
    }
  },

  render2D: function (element, layer, scene) {

    let width = element.properties.get('width').get('length');
    let depth = element.properties.get('depth').get('length');

    let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };

    return (
      <g transform={`translate(${-width / 2},${-depth / 2})`}>
        <rect key='1' x='0' y='0' width={width} height={depth} style={style} />
      </g>
    )
  },


  render3D: function (element, layer, scene) {

    let HEIGHT = 300;
    let width = element.properties.get('width').get('length');
    let depth = element.properties.get('depth').get('length');
    let newAltitude = 0;

    let column = new Three.Object3D();

    let object = new Three.Mesh(new Three.BoxGeometry(width, HEIGHT, depth, 32), material);

    column.add(object);

    if (element.selected) {
      let bbox = new Three.BoxHelper(column, 0x99c3fb);
      bbox.material.linewidth = 10;
      bbox.renderOrder = 5000;
      bbox.material.depthTest = false;
      column.add(bbox);
    }

    column.position.y += HEIGHT / 2 + newAltitude;
    column.position.x += width / 2;


    return Promise.resolve(column);

  }
};
